{
  "renderer": {
    "submit": "送出",
    "submitting": "送出中…",
    "yes": "是",
    "select": "請選擇…",
    "fileUploadUnavailable": "檔案上傳功能尚未開放。",
    "upload": {
      "uploading": "上傳中…",
      "finalizing": "確認中…",
      "cancel": "取消",
      "replace": "更換檔案",
      "remove": "移除",
      "noFile": "未附加檔案。",
      "interrupted": "先前的上傳未完成，請重新選擇檔案。",
      "failedPersisted": "「{{filename}}」上傳失敗，請重新選擇檔案。",
      "allowedTypes": "允許的檔案類型：{{extensions}}",
      "errors": {
        "extensionNotAllowed": "檔案類型不符，僅接受：{{extensions}}",
        "tooLarge": "檔案過大。",
        "tooLargeForNow": "檔案超過 100MB，目前尚不支援，請改用較小的檔案。",
        "locked": "此作品已鎖定，無法上傳或修改檔案。",
        "deadlinePassed": "已超過繳交截止時間。",
        "generic": "上傳失敗，請重試。",
        "genericWithDetail": "上傳失敗：{{detail}}"
      }
    }
  },
  "types": {
    "registrationForm": {
      "label": "報名表單",
      "description": "隊伍報名此競賽時填寫，例如參賽組別、題目與聲明。個別成員的學生資格證明請至「資格驗證」管理，不要放進報名表單。"
    },
    "teamForm": {
      "label": "團隊表單",
      "description": "關於團隊本身的資訊，與成員資料分開收集。個別成員的學籍或在學證明不應放在此處，請至「資格驗證」管理。"
    },
    "submissionForm": {
      "label": "作品繳交表單",
      "description": "隊伍隨作品檔案一併填寫的資訊。"
    },
    "judgeConflictForm": {
      "label": "評審利益迴避表單",
      "description": "讓評審在評分前申報利益衝突。"
    }
  },
  "fieldTypes": {
    "short_text": "短文字",
    "long_text": "長文字",
    "rich_text": "格式化文字",
    "number": "數字",
    "email": "電子郵件",
    "phone": "電話號碼",
    "url": "網址",
    "date": "日期",
    "datetime": "日期時間",
    "radio": "單選",
    "checkbox": "核取方塊",
    "select": "下拉選單",
    "multi_select": "複選",
    "boolean": "是／否",
    "file": "檔案",
    "image": "圖片",
    "pdf": "PDF 檔案",
    "zip": "壓縮檔（ZIP）",
    "heading": "標題（版面用）",
    "description": "說明文字（版面用）",
    "separator": "分隔線（版面用）"
  },
  "eligibilityPointer": {
    "text": "本競賽若啟用學生資格驗證，請在「概覽」管理要求與審核規則。",
    "cta": "管理學生資格要求 →"
  }
}
